import React from "react";
import styled from "styled-components/macro";

const StyleRoot = styled.div`
  height: 100%;

  iframe {
    height: 100%;
  }
`;

export const DocumentPreview: React.FC<{
  document: {
    signedDownloadUrl: string;
    mimeType: string;
  };
  className?: string;
}> = ({ document: { signedDownloadUrl, mimeType }, className }) => {
  return (
    <StyleRoot className={className ?? "preview"}>
      {mimeType === "application/pdf" || mimeType.startsWith("image/") ? (
        <iframe
          src={signedDownloadUrl}
          width="100%"
          frameBorder={0}
          height="500"
        />
      ) : (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            signedDownloadUrl,
          )}`}
          frameBorder={0}
          width="100%"
          height="868"
        />
      )}
    </StyleRoot>
  );
};
